export default "__VITE_ASSET__BJEv5uCw__"